import React from 'react';
import ComingSoon from '@/components/shared/ComingSoonSection';
import './DocumentsPage.scss';



const DocumentsPage = () => {
  return (
    <div className="DocumentsPage">
      <ComingSoon title="DocumentsPage" />
    </div>
  );
};

export default DocumentsPage;